import { LoadState } from "../../constants/enums";
import { IRsaPackage, IRsaPackageState } from "./rsaPackages.types";

/* ---------- INITIAL ENTITY ---------- */
export const initialRsaPackage: IRsaPackage = {
  rsa_package_master_uuid: "",
  package_id: 0,
  old_package_id: 0,
  package_order: 0,
  package_name: "",
  package_price_excluding_gst: 0,
  package_price: 0,
  gst_percentage: 0,
  gst_amount: 0,
  vehicle_type: "",
  city: null,
  package_location_type: "",
  duration: 0,
  duration_type: "",
  package_type: "",
  // additional_features: "",
  // plan_benefits: null,
  card_url: null,
  partner_name: "CROSSROADS",
  no_of_services: 0,
  comment: "",
  status: "ACTIVE",
  company_outlet_uuid: "",
  additional_features: [{ key: null, value: null }],
  plan_benefits: [{ key: null, value: null }],

  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: "",
};

/* ---------- INITIAL REDUX STATE ---------- */
export const initialRsaPackageState: IRsaPackageState = {
  RsaPackage: {
    list: {
      list: [],
      totalRecords: 0,
      loading: LoadState.NotLoaded,
      error: null,
    },
    data: {
      data: null,
      loading: LoadState.NotLoaded,
      error: null,
    },
  },
};
